<template>
  <main class="notification-page">
    <section class="soft-card table-panel">
      <div class="panel-header">
        <h3 class="panel-title">站内信管理</h3>
        <el-button type="primary" size="small" @click="openDialog(null)">发送站内信</el-button>
      </div>
      <el-table :data="notifications" v-loading="loading" stripe size="small">
        <el-table-column label="标题" prop="title" />
        <el-table-column label="类型" prop="type" width="100">
          <template slot-scope="{ row }">
            <el-tag size="mini" :type="typeTagMap[row.type]">{{ typeNameMap[row.type] }}</el-tag>
          </template>
        </el-table-column>
        <el-table-column label="内容" prop="content" show-overflow-tooltip />
        <el-table-column label="发送时间" width="160">
          <template slot-scope="{ row }">{{ $formatTime(row.createdAt) }}</template>
        </el-table-column>
        <el-table-column label="操作" width="120">
          <template slot-scope="{ row }">
            <el-button type="text" size="mini" @click="openDialog(row)">编辑</el-button>
            <el-button type="text" size="mini" class="danger-text" @click="handleDelete(row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
    </section>

    <!-- 发送/编辑弹窗 -->
    <el-dialog :title="dialogTitle" :visible.sync="dialogVisible" width="560px" :close-on-click-modal="false">
      <el-form ref="form" :model="form" :rules="rules" label-width="100px" size="small">
        <el-form-item label="消息类型" prop="type">
          <el-select v-model="form.type" style="width: 200px;">
            <el-option label="系统通知" value="system" />
            <el-option label="账单提醒" value="billing" />
            <el-option label="活动公告" value="activity" />
          </el-select>
        </el-form-item>
        <el-form-item label="标题" prop="title">
          <el-input v-model="form.title" placeholder="请输入标题" />
        </el-form-item>
        <el-form-item label="内容" prop="content">
          <el-input v-model="form.content" type="textarea" :rows="5" placeholder="请输入内容" />
        </el-form-item>
        <el-form-item v-if="!editId" label="接收人" prop="sendMode">
          <el-radio-group v-model="form.sendMode">
            <el-radio label="all">所有客户</el-radio>
            <el-radio label="selected">指定客户</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item v-if="!editId && form.sendMode === 'selected'" label="选择客户">
          <el-select
            v-model="form.recipientIds"
            multiple
            filterable
            placeholder="请选择客户"
            style="width: 100%;">
            <el-option
              v-for="c in customers"
              :key="c.id"
              :label="c.name + ' (' + c.code + ')'"
              :value="c.id" />
          </el-select>
        </el-form-item>
      </el-form>
      <span slot="footer">
        <el-button size="small" @click="dialogVisible = false">取消</el-button>
        <el-button size="small" type="primary" :loading="submitting" @click="submit">确定</el-button>
      </span>
    </el-dialog>
  </main>
</template>

<script>
export default {
  name: 'NotificationPage',
  data() {
    return {
      loading: false,
      submitting: false,
      notifications: [],
      customers: [],
      dialogVisible: false,
      editId: null,
      form: {
        type: 'system',
        title: '',
        content: '',
        sendMode: 'all',
        recipientIds: []
      },
      rules: {
        type: [{ required: true, message: '请选择类型', trigger: 'change' }],
        title: [{ required: true, message: '请输入标题', trigger: 'blur' }],
        content: [{ required: true, message: '请输入内容', trigger: 'blur' }]
      },
      typeNameMap: {
        system: '系统通知',
        billing: '账单提醒',
        activity: '活动公告'
      },
      typeTagMap: {
        system: '',
        billing: 'warning',
        activity: 'success'
      }
    }
  },
  computed: {
    dialogTitle() {
      return this.editId ? '编辑站内信' : '发送站内信'
    }
  },
  mounted() {
    this.fetchNotifications()
    this.fetchCustomers()
  },
  methods: {
    async fetchNotifications() {
      this.loading = true
      try {
        const res = await this.$http.get('/admin/notifications', {
          params: { page: 1, pageSize: 1000 }
        })
        this.notifications = res.records || []
      } catch (e) {
        this.$message.error('加载通知列表失败')
      } finally {
        this.loading = false
      }
    },
    async fetchCustomers() {
      try {
        const res = await this.$http.get('/admin/customers', {
          params: { page: 1, pageSize: 1000 }
        })
        this.customers = res.records || []
      } catch (e) {
        // 静默失败
      }
    },
    openDialog(row) {
      if (row) {
        this.editId = row.id
        this.form = {
          type: row.type,
          title: row.title,
          content: row.content,
          sendMode: 'all',
          recipientIds: []
        }
      } else {
        this.editId = null
        this.form = { type: 'system', title: '', content: '', sendMode: 'all', recipientIds: [] }
      }
      this.dialogVisible = true
    },
    submit() {
      this.$refs.form.validate(async valid => {
        if (!valid) return
        this.submitting = true
        try {
          const payload = {
            type: this.form.type,
            title: this.form.title,
            content: this.form.content,
            recipientIds: this.form.sendMode === 'all' ? null : this.form.recipientIds
          }
          if (this.editId) {
            await this.$http.put('/admin/notifications/' + this.editId, payload)
            this.$message.success('修改成功')
          } else {
            await this.$http.post('/admin/notifications', payload)
            this.$message.success('发送成功')
          }
          this.dialogVisible = false
          this.fetchNotifications()
        } catch (e) {
          const msg = e.response?.data?.error
          this.$message.error(msg || '操作失败')
        } finally {
          this.submitting = false
        }
      })
    },
    handleDelete(row) {
      this.$confirm('确认删除该站内信？删除后所有用户的未读记录也会一并删除。', '提示', {
        confirmButtonText: '删除',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        try {
          await this.$http.delete('/admin/notifications/' + row.id)
          this.$message.success('删除成功')
          this.fetchNotifications()
        } catch (e) {
          const msg = e.response?.data?.error
          this.$message.error(msg || '删除失败')
        }
      }).catch(() => {})
    }
  }
}
</script>

<style scoped>
.notification-page {
  padding: 0 24px 76px;
}

.table-panel {
  padding: 20px;
}

.panel-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 16px;
}

.panel-title {
  margin: 0;
  font-size: 15px;
  font-weight: 600;
  color: var(--text);
}

.danger-text {
  color: var(--red) !important;
}
</style>
